import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import {
  Banner,
  Box,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import useSearchParams from './hooks.useSearchParams';
import useIntl from '../../hooks/useIntl';
import messages from './messages';

/**
 * ENG-31236: while a unit transfer is being set up, the user is sent here (isTransfer=true) to pick
 * the destination unit. Leaving before assigning one abandons the transfer setup, so warn them in the
 * same slot the NAUR banner uses. Gated on `unitTransfers` because the same isTransfer URL is also
 * used by the pre-flag legacy transfer path (see hooks.useAssignUnit.jsx).
 */
const TransferNavigationWarningBanner = () => {
  const { isTransfer } = useSearchParams();
  const { unitTransfers: unitTransfersFlag } = useFlags();
  const intl = useIntl();

  if (!unitTransfersFlag || !isTransfer) return null;

  return (
    <Box sx={{ marginTop: 1 }}>
      <Banner
        status={'warning'}
        message={
          intl?.formatMessage(messages.transferNavigationWarningBanner) ??
          messages.transferNavigationWarningBanner.defaultMessage
        }
      />
    </Box>
  );
};

export default TransferNavigationWarningBanner;
